import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('modules.common.FieldDataProvider', {
    fieldEmptyValueText: 'Empty',
    fieldAnyValueText: 'Any value',
    fieldNotEmptyValueText: 'Not empty',
});
